import script from "./RoomTopSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomTopSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./RoomTopSkeleton.vue?vue&type=style&index=0&id=fe0291f8&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe0291f8"]])

export default __exports__